import * as React from 'react'

import premiumFeaturesData from './premium_features_data'

import { Tooltip, EXTRA_SMALL_ICON_BASE_SRC, } from '../../../Shared/index'

const checkImg = <img alt="" src={`${EXTRA_SMALL_ICON_BASE_SRC}/check.svg`} />

const TEACHER_BASIC = 'Teacher Basic'
const TEACHER_PREMIUM = 'Teacher Premium'
const SCHOOL_PREMIUM = 'School Premium'
const DISTRICT_PREMIUM = 'District Premium'

const titleToColumnClassName = (title) => {
  switch(title) {
    case TEACHER_BASIC:
      return 'teacher-basic'
    case TEACHER_PREMIUM:
      return 'teacher-premium'
    case SCHOOL_PREMIUM:
      return 'school-premium'
    case DISTRICT_PREMIUM:
      return 'district-premium'
  }
}

const PremiumFeature = ({ column, data, onTeacherPage, }) => {
  const { title, tooltipText, teacherBasic, teacherPremium, schoolPremium, districtPremium, schoolPremiumTitle, districtPremiumTitle, hideOnTeacherPage, id, } = data

  if (onTeacherPage && hideOnTeacherPage) {
    return null
  }

  let included
  let tooltipTriggerText = title

  switch(column) {
    case TEACHER_BASIC:
      included = teacherBasic
      break;
    case TEACHER_PREMIUM:
      included = teacherPremium
      break;
    case SCHOOL_PREMIUM:
      included = schoolPremium
      tooltipTriggerText = schoolPremiumTitle || title
      break;
    case DISTRICT_PREMIUM:
      included = districtPremium
      tooltipTriggerText = districtPremiumTitle || title
      break;
  }

  return (
    <li className={included ? 'included' : 'excluded'} id={id}>
      {included ? checkImg : <span className="img-placeholder" /> }
      <span className="sr-only">{included ? 'Included: ' : 'Not included: '}</span>
      <Tooltip
        tooltipText={tooltipText}
        tooltipTriggerText={tooltipTriggerText}
      />
    </li>
  )
}

const PremiumFeaturesColumn = ({ subheader, subheaderButton, subheaderDescription, title, onTeacherPage, }) => {
  return (
    <section aria-labelledby={title} className={`premium-features-column ${titleToColumnClassName(title)}`}>
      <div className="header-and-subheader-wrapper">
        <div className="header">
          <h2 id={title}>{title}</h2>
        </div>
        <div className="subheader-section">
          <p className="subheader">{subheader}</p>
          <p className="subheader-description">{subheaderDescription}</p>
          {subheaderButton}
        </div>
      </div>
      {premiumFeaturesData.map((premiumFeatureSection) => {
        const { sectionTitle, items, } = premiumFeatureSection
        return (
          <section className="premium-feature-section" key={sectionTitle}>
            <h3>{sectionTitle}</h3>
            <ul>
              {items.map(item => {
                return <PremiumFeature column={title} data={item} key={item.title} onTeacherPage={onTeacherPage} />
              })}
            </ul>
          </section>
        )
      })}
    </section>
  )
}

export default PremiumFeaturesColumn
